// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__TA1tp","backBtn":"styles_backBtn__KZvGp"};